import jwtDefaultConfig from './jwtDefaultConfig'


import { eventBus } from '@/main';


export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        const { config, response } = error

        // 401 on any call except the login attempt itself means the stored
        // token is invalid (expired, or issued by a previous version of the
        // app with a different signature). There is no refresh endpoint on
        // this backend, so purge the session and send the user to the login
        // page instead of retrying forever.
        const isLoginRequest = config && config.url && config.url.includes(this.jwtConfig.loginEndpoint)
        if (response && response.status === 401 && !isLoginRequest) {
          localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
          localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
          localStorage.removeItem('userData')
          localStorage.removeItem('sessionId')
          localStorage.removeItem('company')
          if (!window.location.pathname.endsWith('/login')) {
            window.location.assign((process.env.BASE_URL || '/') + 'login')
          }
          return Promise.reject(error)
        }

        eventBus.$emit('show-sweetalert-error', response);
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  // setCurrentCompany(company) {
  //   localStorage.setItem("company", company);
  // }

  setToken(data) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, data.token);
  }

  // getBaseToken() {
  //   return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  // }

  setUserData(value) {
    localStorage.setItem('userData', JSON.stringify(value));
    localStorage.setItem("sessionId", value.sessionId);
    localStorage.setItem("company", value.company);
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint + '', null, {
      headers: {
        username: args[0].email,
        password: args[0].password
      }
    })
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}
